// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"list-demand"},"nodeName":"g","children":[{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M11 5H21M21 10.0001H11M3 15H21M3 20H21","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M7 3H3.5C3.22386 3 3 3.22386 3 3.5V6C3 6.27614 3.22386 6.5 3.5 6.5H6.5C6.77614 6.5 7 6.72386 7 7V9.5C7 9.77614 6.77614 10 6.5 10H3","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-list-demand')
export default class ListDemandIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'list-demand',
    }
  }
}
